import { Injectable, ComponentFactoryResolver } from '@angular/core'
import { IMaskFieldLog } from '../single-mask-field/single-mask-field.component'
// import { AuthHttpService } from 'client-my-channel-lib/src/services/auth/auth-http.service';
import { HttpClient } from '@angular/common/http'
import * as Moment from 'moment'
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class MaskFieldService {
  fieldPatterns: any = {
    MSISDN: { fieldName: 'MSISDN', front: 3, tail: 4, replacer: 'X' },
    FBBID: { fieldName: 'FBBID', front: 2, tail: 4, replacer: 'X' },
    CREDITCARD: {
      fieldName: 'Credit/Debit card no',
      front: 6,
      tail: 4,
      replacer: 'X'
    },
    IDCARD: {
      fieldName: 'Citizen ID/Passport no',
      front: 0,
      tail: 4,
      replacer: 'X'
    },
    // PASSPORT:   {fieldName: '', front: 0, tail: 4, replacer: 'X'},
    BANKACC: { fieldName: 'Bank Account', front: 4, tail: 3, replacer: 'X' },
    BLACKLIST: {
      fieldName: 'Black list flag',
      front: 0,
      tail: 0,
      replacer: 'Watch list'
    },
    FULLNAME: {
      fieldName: 'Name Surname',
      front: 0,
      tail: 0,
      replacer: 'X',
      maskPattern: /\s(.*)/g
    },
    EMAIL: { fieldName: 'Email address', front: 3, tail: 0, replacer: 'X' },
    BIRTHDATE: { fieldName: 'Birthday', front: 4, tail: 0, replacer: 'X' },
    ADDRESS: { fieldName: 'Address', front: 0, tail: 0, replacer: '' },
    PASSWORD: { fieldName: 'Password', front: 0, tail: 0, replacer: '*' }


  }

  window: any = window
  validator: any = this.window.validator

  constructor(
    private http: HttpClient // private http: AuthHttpService
  ) {}

  validateFieldType(fieldType: string): number {
    // -1 : invalid
    //  0 : normal text
    //  1 : mask field
    return fieldType
      ? this.fieldPatterns[fieldType] !== undefined
        ? 1
        : -1
      : 0
  }

  getFieldName(field: string): string {
    const s = field.split(",")
    if (s.length >= 2) {
      let r: Array<string> = [];
      const m = s.forEach(element => {
        r.push(this.fieldPatterns[element] ? this.fieldPatterns[element].fieldName : element);
      });
      return r.join(',');
    } else {
      return this.fieldPatterns[field] ? this.fieldPatterns[field].fieldName : field
    }
  }

  addLog(logData: IMaskFieldLog): Promise<any> {
    const api: string = '/api/maskLogData'
    logData['accessDate'] = Moment().format('YYYYMMDD_HHmmss')
    const reqData = {
      operation: 'add',
      logData: logData
    }
    return this.http.post(api, reqData).toPromise()
  }

  validateMSISDNFormat(inpText: string, removeInvalidChar = false) {
    let inputText: string;
    let result: string[] = [];
    const inpTextSplit = inpText.split(',');

    for (let i = 0; i < inpTextSplit.length; i++) {
      inputText = inpTextSplit[i];

      if (removeInvalidChar) {
        if (inputText.slice(0, 2) !== '02') {
          inputText = inputText.replace(/[^0-9]/g, '') // remove all none numbers
        } else {
          inputText = inputText.split('-').join('') // remove '-'
        }
      }
      if (inputText.indexOf('-') < 0) {
        const number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
        if (inputText.slice(0, 2) !== '02') {
          inputText = [
            inputText.slice(0, 3),
            '-',
            inputText.slice(3, 6),
            '-',
            inputText.slice(6)
          ].join('')
        } else {
          if (number.includes(inputText.slice(9, 10))) {
            inputText = [
              inputText.slice(0, 3),
              '-',
              inputText.slice(3, 6),
              '-',
              inputText.slice(6, 9),
              ' - ',
              inputText.slice(9)
            ].join('')
          } else {
            if (
              !number.includes(inputText.slice(9, 10)) &&
              number.includes(inputText.slice(10, 11))
            ) {
              inputText = [
                inputText.slice(0, 3),
                '-',
                inputText.slice(3, 6),
                '-',
                inputText.slice(6, 9),
                ' -',
                inputText.slice(9)
              ].join('')
            } else if (
              !number.includes(inputText.slice(9, 10)) &&
              !number.includes(inputText.slice(10, 11)) &&
              number.includes(inputText.slice(11, 12))
            ) {
              inputText = [
                inputText.slice(0, 3),
                '-',
                inputText.slice(3, 6),
                '-',
                inputText.slice(6, 9),
                ' -',
                inputText.slice(9)
              ].join('')
            } else {
              inputText = [
                inputText.slice(0, 3),
                '-',
                inputText.slice(3, 6),
                '-',
                inputText.slice(6)
              ].join('')
            }
          }
        }
      }

      result.push(inputText);
    }
    return result.join(',');
  }

  validateDateFormat(inputText: string) {
    if (inputText.indexOf('/') < 0) {
      inputText = [
        inputText.slice(0, 2),
        '/',
        inputText.slice(3, 5),
        '/',
        inputText.slice(4)
      ].join('')
    }
    return inputText
  }

  validateIdCardFormat(inputText: string) {
    if (inputText.indexOf(' ') < 0) {
      inputText = [
        inputText.substring(0, 1),
        inputText.substring(1, 5),
        inputText.substring(5, 10),
        inputText.substring(10, 12),
        inputText.substring(12, 13)
      ].join(' ')
    }
    return inputText
  }

  maskDate(date: string) {
    return [date.slice(0, 2), '/', date.slice(3, 5), '/XXXX'].join('')
  }

  maskMSISDN(msisdn: string) {
    const msisdnSplit = msisdn.split(',');
    let result: string[] = [];

    for (let i = 0; i < msisdnSplit.length; i++) {
      result.push([msisdnSplit[i].slice(0, 3), '-XXX-', msisdnSplit[i].slice(8)].join(''));
    }

    return result.join(',');
    //return [msisdn.slice(0, 3), '-XXX-', msisdn.slice(8)].join('')
  }

  maskEmail(email:string): string {
    const patConf = this.fieldPatterns['EMAIL']
    if (!this.validator.isEmail(email)) {
      return 'Invalid email'
    }

    return (
      email.substr(0, patConf.front) +
      patConf.replacer +
      '@' +
      new Array(4).join(patConf.replacer) +
      '.' +
      new Array(4).join(patConf.replacer) +
      '.' +
      new Array(3).join(patConf.replacer)
    )
  }

  maskFullName(fullname: string):any {
    const patConf = this.fieldPatterns['FULLNAME']
    if (fullname) {
      const lastname = fullname.indexOf(' ')
      if (lastname > 0 && lastname < fullname.length - 1) {
        // space must between words
        return (
          fullname.substr(0, lastname) +
          ' ' +
          new Array(9).join(patConf.replacer)
        )
      } else {
        return fullname
      }
    }
  }

  maskBlackList(text:any): string {
    return this.fieldPatterns['BLACKLIST'].replacer
  }

  maskWithPattern(fieldType: string, inputText: string) {
    const patConf = this.fieldPatterns[fieldType]
    let maskText: string
    if (patConf !== undefined) {
      if (inputText && inputText.length < patConf.front + patConf.tail) {
        maskText = 'Invalid text'
      } else {
        const patternStr: string =
          '.(?=' + new Array(patConf.tail + 1).join('.') + ')'
        const pattern: any = patConf.maskPattern
          ? patConf.maskPattern
          : new RegExp(patternStr, 'g')
        maskText =
          (patConf.front ? inputText.slice(0, patConf.front) : '') +
          inputText.slice(patConf.front).replace(pattern, patConf.replacer)
      }
    } else {
      maskText = inputText
    }
    return maskText
  }

  getMaskText(type:any, text:any, removeInvalidChar = false) {
    const plainText = text
    if (text.length == 0) {
      return [];
    }

    const text_ = text.split(',')
    const type_ = type.split(',')
    const plainText_ = plainText.split(',')
    let result: Array<any> = []

    for (let i = 0; i < type_.length; i++) {
      let mask: string

      switch (type_[i]) {
        case 'ADDRESS':
          mask = text_[i]
          break
        case 'FULLNAME':
          mask = this.maskFullName(text_[i])
          break
        case 'EMAIL':
          mask = this.maskEmail(text_[i])
          break
        case 'BIRTHDATE':
          text = this.validateDateFormat(text_[i])
          mask = this.maskDate(plainText_[i])
          break
        case 'MSISDN':
          // text = this.validateMSISDNFormat(text_[i], removeInvalidChar)
          // mask = this.maskMSISDN(text_[i])
          text = this.validateMSISDNFormat(text, removeInvalidChar)
          mask = this.maskMSISDN(text)
          break
        case 'BLACKLIST':
          mask = this.maskBlackList(text_[i])
          break
        case 'IDCARD':
          text = this.validateIdCardFormat(text_[i])
          mask = this.maskWithPattern(type_[i], plainText_[i])
          mask = this.validateIdCardFormat(mask)
          break
        case 'PASSWORD':
          mask = '******'
          break
        default:
          mask = this.maskWithPattern(type_[i], text_[i])
      }

      result.push({ text, mask })
    }

    return result
  }
}
